import React from 'react';
import { Reset as ResetComponent } from '~/components/Auth/Reset';

export function Reset() {
    return (
        <div className="container">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <ResetComponent />
                    </div>
                </div>
            </div>
        </div>
    );
}
